module.exports = __webpack_public_path__ + "static/media/md-arrow-dropright.7666daaa.svg";